<template>

    <CardShell>

        <!-- header -->
        <BackLinkHeading :route="isHistoric ? '/rentals-history' : '/upcoming-rentals'" :linkText="isHistoric ? 'Rental History' : 'Upcoming Rentals'" :sizeDependent="false" :text="rental.title"/>
        
        <div class="ph4">

            <div class="flex justify-between items-center pv3 bb b--light-gray">

                <!-- rental details -->
                <div>
                    <BoldedLabelDetail class="mb2" title="From: " :value="data.startDate | moment('MMM DD [at] h:mma')"/>
                    <BoldedLabelDetail class="mb2" title="To: " :value="data.endDate | moment('MMM DD [at] h:mma')"/>
                    <BoldedLabelDetail title="Handoff: " :value="rental.handoff"/>
                </div>

                <!-- add to calender image -->
                <img src="@/assets/img/icon_set_reminder.svg">
            </div>

            <!-- view invoice button -->
            <div class="pv3">
                <router-link to="/invoice-detail" class="no-underline">
                <TooliabaButton class="w-50-m">View Invoice</TooliabaButton>
                </router-link>
            </div>

        </div>
    </CardShell>

</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import BoldedLabelDetail from '@/components/controls/BoldedLabelDetail.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

const RENTAL = {
    title: 'Bostitch 3.5-in Cordless Framing Nailer',
    from: 'Jun 25, 2018 at 7:00am',
    to: 'Jun 29, 2018 at 7:00am',
    handoff: 'Paul will pick-up & return'
};

export default {
    data() {
        return {
            rental: RENTAL
        };
    },
    components: {
        CardShell,
        BackLinkHeading,
        BoldedLabelDetail,
        TooliabaButton
    },
    props: {
        isHistoric: {
            type: Boolean
        },
        data: {
            type: Object
        }
    }
};
</script>
